import React, {useCallback} from 'react';
import cx from 'classnames';
import toast from 'react-hot-toast';
import { CloseIcon } from '../../assets/icons';
import { editCustomer } from '../../backend-services';
import CreateForm from './Create/CreateForm';
import { CustomerT } from '../../types';
import { ICustomer } from '../../@types';

interface EditCustomerProps {
  show: boolean;
  onClose?: () => void;
  customer: CustomerT;
  customerId: string;
  showIsLoading:any
  hideIsLoading: any;
  onEditSuccess: (updatedData: CustomerT) => void; 
}

const EditCustomer = ({ show, onClose, customer, customerId, showIsLoading, hideIsLoading,  onEditSuccess}: EditCustomerProps) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [, setErrorMessage] = React.useState('');

  const handleEditSuccess = (updatedData:CustomerT) => {
    onEditSuccess && onEditSuccess(updatedData);
  };

  const handleEditCustomer = useCallback(async (customer: CustomerT) => {
    setIsLoading(true);
    try {
     
      const data = await editCustomer(customerId, customer);      
      // setIsLoading(false);
      setIsOpen(false);
     
      toast.success('Customer details updated successfully!');
      // const isLoaded = showIsLoading()
      handleEditSuccess(data);
      onClose && onClose();
    } catch (e) {
      console.log(e);
      setErrorMessage('Unable to update customer.');
      setIsLoading(false);
    }
    
  },  [customer, customerId, handleEditSuccess, onClose]);

  const handleClose = () => {
    setTimeout(() => {});
    setIsOpen(false);
    onClose && onClose();
  };

  React.useEffect(() => {
    setIsOpen(show);
  }, [show]);



  return isOpen ? (
    <>
      {/* Modal Background */}
      <div
        aria-hidden="false"
        className="fixed top-0 right-0 left-0 z-50 h-[400vh] lg:h-[200vh] overflow-y-auto overflow-x-hidden items-start flex bg-gray-900 bg-opacity-50"
      >
        <div
          className={cx({
            'relative z-50 ': true,
            'p-3 max-w-lg bg-white shadow h-[200vh] 540:h-[600vh] lg:h-[200vh] xl:h-[200vh]': true,
            'animate-slide-in': isOpen,
          })}
        >
          {/* MODAL HEADER */}
          <div className='flex px-[30px] items-center justify-between'>
            <div className="flex items-start justify-between p-3">
            <h3 className="text-[25px] font-bold ">{'Add New Customer'}</h3>
            </div>

            <button
              aria-label="Close"
              className="xl:inline-flex xl:items-center rounded-lg bg-transparent text-red-400"
              type="button"
              onClick={handleClose}
            >
              <CloseIcon/>
            </button>
          </div>

          {/* MODAL BODY */}
          <div className="p-4 pt-10 w-[350px] sm:w-full h-screen">
            <CreateForm
              isLoading={isLoading}
              show={true}
              onSubmit={handleEditCustomer}
              buttontitle={'Update Changes'}
              customer={customer} setFormData={function (value: React.SetStateAction<ICustomer>): void {
                throw new Error('Function not implemented.');
              } }              
            />
          </div>
        </div>
      </div>
    </>
  ) : null;
};

export { EditCustomer };
